import { observable } from 'mobx';

export class EditorPageModel {
  @observable
  loading: boolean = false;
}